import React, { useState } from "react";
import { Mail, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("शुक्रिया! आप अब Bodh Networks का हिस्सा हैं.");
      setEmail("");
    } catch {
      toast.error("कुछ गलत हुआ. कृपया पुनः प्रयास करें.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="my-16" data-testid="newsletter-section">
      <div className="relative rounded-3xl overflow-hidden bodh-gradient p-10 sm:p-16">
        <div className="absolute inset-0 opacity-30 bodh-world-bg" />
        <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-white/20 blur-3xl" />
        <div className="relative grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7 text-white">
            <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-md border border-white/30 px-3 py-1 rounded-full text-xs font-outfit font-bold uppercase tracking-widest">
              <Sparkles className="h-3 w-3" /> Stay Aware
            </div>
            <h2 className="mt-3 font-devanagari font-black text-3xl sm:text-4xl lg:text-5xl leading-tight">
              सिर्फ खबर नहीं, बोध — हर सुबह
            </h2>
            <p className="mt-3 text-white/90 font-devanagari max-w-lg">
              Bodh Networks का हिंदी न्यूजलेटर — दिन की सबसे अहम खबरें, गहरी पड़ताल और सटीक विश्लेषण, सीधे आपके इनबॉक्स में.
            </p>
          </div>
          <form onSubmit={submit} className="md:col-span-5" data-testid="newsletter-form">
            <div className="bg-white p-2 rounded-full flex items-center shadow-2xl">
              <Mail className="h-5 w-5 ml-3 text-zinc-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="आपका ईमेल पता"
                data-testid="newsletter-input"
                className="flex-1 px-3 py-3 outline-none text-zinc-900 font-devanagari bg-transparent"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit"
                className="bg-zinc-900 hover:bg-black text-white font-outfit font-bold text-sm px-5 py-3 rounded-full disabled:opacity-60"
              >
                {loading ? "..." : "जुडें"}
              </button>
            </div>
            <p className="text-white/80 text-xs mt-3 font-hind ml-2">कोई स्पैम नहीं. कभी भी अनसब्सक्राइब करें.</p>
          </form>
        </div>
      </div>
    </section>
  );
}
